import { render } from "./tw-col.vue?vue&type=template&id=397efeac"
import script from "./tw-col.vue?vue&type=script&lang=js"
export * from "./tw-col.vue?vue&type=script&lang=js"
script.render = render

export default script